export default __webpack_public_path__ + "static/media/easytrack.7e2a98eb.png";